/**
 * ETML
 * @ De: Theo Bensaci
 * @ Date: 18:53 23.04.2023
 * @ Description: stats en haut de l'écrans
 */

import "./index.css"

import React, { useState } from 'react';
import GameAdmin from "../../GameClass/gameAdmin";

export default function StatsShower(props) {
  return (
    <div className="StatsShower">
        <p>{props.time}</p>
        <p>{props.score}</p>
        <p>{props.level}</p>
    </div>
  );
}